import APIUtils from "../../../utils/APIUtils";

export const QUERY_COMPANY_UNITS = "QUERY_COMPANY_UNITS";

export const queryUnits = companyId => ({
    type: QUERY_COMPANY_UNITS,
    payload: APIUtils.get(
        `/companies/${companyId}/units?limit=1000`
    )
});